import styled from 'styled-components';

export const AccordionTitle = styled.button`
  display: flex;
  justify-content: space-between;
  background-color: #eee;
  color: #333;
  cursor: pointer;
  padding: 18px;
  width: 100%;
  border: none;
  text-align: left;
  outline: none;
  font-size: 1.1rem;
  font-weight: 450;
  border-radius: 10px;

  :hover {
    background-color: #ccc;
  }
`;

export const AccordionDiv = styled.div`
  background-color: white;
  overflow-wrap: break-word;
  width: 100%;
  margin-top: 1rem;
`;
